import React, { useEffect, useState } from "react";
import api, { formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";
import { UserRoundPlus, KeyRound } from "lucide-react";

export function PortalAccess({ id, role }) {
  const [users, setUsers] = useState([]);
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [issued, setIssued] = useState(null);
  const load = () => api.get(`/v3/loanfile/${id}/portal-access`).then((r) => setUsers(r.data.users)).catch(() => {});
  useEffect(() => { load(); }, [id]); // eslint-disable-line
  const grant = () => api.post(`/v3/loanfile/${id}/portal-access`, { email, name })
    .then((r) => { setIssued(r.data); toast.success(r.data.temporary_password ? "Borrower login issued" : "Existing login linked"); setEmail(""); load(); })
    .catch((e) => toast.error(formatApiErrorDetail(e.response?.data?.detail) || e.message));
  const can = ["admin", "ops", "credit"].includes(role);
  return (
    <div className="bg-white border border-slate-200 p-5 mb-4" data-testid="portal-access">
      <div className="flex items-center gap-2 mb-2"><UserRoundPlus size={15} strokeWidth={1.5} /><span className="font-semibold text-slate-900 text-sm">Borrower portal access</span><span className="text-[11px] text-slate-400">· borrower sees only this loan: schedule, invoices, documents, e-sign</span></div>
      {users.length > 0 && <div className="text-[12px] text-slate-600 mb-2" data-testid="portal-users">{users.map((u) => <div key={u.email}>{u.email} <span className="text-slate-400">· {u.name} · since {String(u.created_at).slice(0, 10)}</span></div>)}</div>}
      {can && (
        <div className="flex gap-2 flex-wrap">
          <input data-testid="portal-email" className="rf-input max-w-[260px]" placeholder="borrower@company.com" value={email} onChange={(e) => setEmail(e.target.value)} />
          <input data-testid="portal-name" className="rf-input max-w-[200px]" placeholder="Contact name" value={name} onChange={(e) => setName(e.target.value)} />
          <button data-testid="portal-grant-btn" onClick={grant} disabled={!email} className="rf-btn-primary"><KeyRound size={12} /> Grant login</button>
        </div>
      )}
      {issued?.temporary_password && <div className="mt-3 border border-amber-300 bg-amber-50 p-3 text-[12px]" data-testid="portal-temp-password">Temporary password for <b>{issued.email}</b>: <code className="font-mono text-sm bg-white border px-1.5">{issued.temporary_password}</code> — shown once. {issued.note}</div>}
    </div>
  );
}
